import { CommonButton } from "components/common/button/Button";
import React from "react";
import { Modal, Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "./otpActivationModal.scss";
import { useTranslation } from "react-i18next";
const OtpActivationModal = ({ show, onHide, handleConfirm, heading }) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      size="sm"
      className="position-absolute"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Container fluid>
        <Modal.Body>
          <>
            <div className="d-flex justify-content-end position-absolute end-0 top-0 p-3 ">
              <FontAwesomeIcon
                className="fa-xl"
                icon={faTimes}
                size="25px"
                onClick={onHide}
                style={{
                  cursor: "pointer",
                }}
              />
            </div>

            <h3 className="text-center mb-4">{heading}</h3>

            <div className="d-flex justify-content-center">
              <CommonButton
                title="Confirm"
                margin="0 5px 0 0"
                border="none"
                borderRadius="5px"
                textTransform="uppercase"
                click={handleConfirm}
              />
              <CommonButton
                title={t("cancel")}
                margin="0 0 0 5px"
                border="none"
                borderRadius="5px"
                textTransform="uppercase"
                click={onHide}
              />
            </div>
          </>
        </Modal.Body>
      </Container>
    </Modal>
  );
};

export default OtpActivationModal;
